import { ServiceResult } from '../models';
import {
  CreateRecipeIngredientHeaderRequest,
  DeleteRecipeIngredientHeaderRequest,
  RecipeIngredientHeader,
  UpdateRecipeIngredientHeaderRequest,
} from '../models/recipe-ingredient-header.models';
import ApiService from './api-service';

class RecipeIngredientHeaderService extends ApiService {
  private static classInstance: RecipeIngredientHeaderService;

  private constructor() {
    super('RecipeIngredientHeader');
  }

  public static getInstance(): RecipeIngredientHeaderService {
    if (!this.classInstance) {
      this.classInstance = new RecipeIngredientHeaderService();
    }
    return this.classInstance;
  }

  public getRecipeIngredientHeader(
    recipeIngredientHeaderId: string,
    customerId: string
  ): ServiceResult<RecipeIngredientHeader> {
    return this.get(
      `${this.baseUrl}/GetRecipeIngredientHeader?recipeIngredientHeaderId=${recipeIngredientHeaderId}&customerId=${customerId}`
    );
  }

  public getRecipeIngredientHeaders(customerId: string): ServiceResult<RecipeIngredientHeader[]> {
    return this.get(`${this.baseUrl}/GetRecipeIngredientHeaders?customerId=${customerId}`);
  }

  public createRecipeIngredientHeader(
    request: CreateRecipeIngredientHeaderRequest
  ): ServiceResult<RecipeIngredientHeader> {
    return this.post(`${this.baseUrl}/CreateRecipeIngredientHeader`, request);
  }

  public updateRecipeIngredientHeader(
    request: UpdateRecipeIngredientHeaderRequest
  ): ServiceResult<RecipeIngredientHeader> {
    return this.post(`${this.baseUrl}/UpdateRecipeIngredientHeader`, request);
  }

  public deleteRecipeIngredientHeader(request: DeleteRecipeIngredientHeaderRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeIngredientHeader`, request);
  }
}

export default RecipeIngredientHeaderService;
